import { http } from '@/http/axios.js'
import axios from 'axios'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { showScreenLoading, hideScreenLoading } from '@/http/loading.js'
import { Message } from 'element-ui'
import { dateFormat } from '@/utils/index.js'
// 列表
export function getListAPI(params) {
  return http({
    url: '/admin/capital/withdraw/page',
    method: 'get',
    params
  })
}
// 详情
export function getDetailAPI(params) {
    return http({
        url: '/admin/capital/withdraw/detail',
        method: 'get',
        params
    })
}
// 打款
export function remitAPI(data) {
  return http({
    url: '/admin/capital/withdraw/remit',
    method: 'post',
    data
  })
}
// 打款
export function refuseAPI(data) {
  return http({
    url: '/admin/capital/withdraw/refuse',
    method: 'post',
    data
  })
}

// 全部导出
export function DownloadAPI(data) {
  showScreenLoading()
  axios({
    method: 'post',
    url: '/api/admin/capital/withdraw/export',
    responseType: 'blob',
    data,
    headers: {
      Authorization: getToken() || ''
    }
  })
    .then(async res => {
      hideScreenLoading();
      let data = res.data;
      let url = window.URL.createObjectURL(new Blob([data]));
      let a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      let filename = `OK租机资方提现审核${dateFormat()}.xlsx`;
      a.setAttribute('download', decodeURIComponent(filename));
      document.body.appendChild(a);
      a.click(); //执行下载
      window.URL.revokeObjectURL(a.href); //释放url
      document.body.removeChild(a); //释放标签
    })
    .catch(error => {
      hideScreenLoading();
      console.log(error);
    })
}
